module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, undefined) {
	'use strict';
	fox.registerWidget('Social_Favorite', {
		
		configure: function() {
			this.registerOptions('', {
				'handleDom.toggle': {
					event: 'click',
					target: '.bookmark',
					callback: fox.bind(this.saveDomHandler, this),
				},
				subject: 'content',
				template: 'social_favorite',
				container: '.bookmark',
				'methods.load': 'social.favorite.load',
				'methods.save': 'social.favorite.save'
			});

			this.callParent('configure', arguments);
		},

		saveDomHandler: function(elt) {
			var 
				targetId = 
					parseInt(elt.getAttribute('data-target-id')) || 
					parseInt(elt.parentNode.getAttribute('data-target-id'));
			
			this.save(targetId);
		},

		save: function(targetId) {
			if(this.data[targetId] !== undefined){
				this.data[targetId].isFavorite = this.data[targetId].isFavorite ? 0 : 1;
			}

			this.render();

			this.getApi('save').send({
				targetId: targetId, 
				isHidePreloader: true,
				subject: this.getOption('subject')
			}, false);
		}

	}, 'Social_Activity');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/social/favorite.js
// module id = 473
// module chunks = 4